import * as React from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import PaymentIcon from "@mui/icons-material/Payment";
import { useNavigate } from "react-router-dom";

const MonthsArr = [
  "JANUARY ",
  "FEBRUARY ",
  "MARCH ",
  "APRIL ",
  "MAY ",
  "JUNE ",
  "JULY ",
  "AUGUST ",
  "SEPTEMBER ",
  "OCTOBER ",
  "NOVEMBER ",
  "DECEMBER ",
];

function PaymentDetails() {
  const navigate = useNavigate();
  const payment = JSON.parse(sessionStorage.getItem("payment"));

  return (
    <Grid item xs={12} md={6}>
      <CardActionArea
        component="a"
        href="#"
        onClick={() => navigate("/paymentpage")}
      >
        <Card sx={{ display: "flex" }}>
          <CardContent sx={{ flex: 1 }}>
            <Typography component="h2" variant="h5">
              Payment Details <PaymentIcon />
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              Latest Payment Month :
            </Typography>
            <Typography variant="subtitle2" paragraph fontWeight="bold">
              {payment
                ? MonthsArr[parseInt(payment?.month)] + payment?.year
                : "No Payment"}
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              Payment Status :
            </Typography>
            <Typography variant="subtitle2" paragraph fontWeight="bold">
              {payment?.status.toUpperCase()}
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              Payment Slip :
            </Typography>
            <Typography variant="subtitle2" paragraph fontWeight="bold">
              -
            </Typography>
          </CardContent>
          <CardMedia
            component="img"
            sx={{ width: 160, display: { xs: "none", sm: "block" } }}
            image="https://source.unsplash.com/random/?blog/"
            alt="random"
          />
        </Card>
      </CardActionArea>
    </Grid>
  );
}

// FeaturedPost.propTypes = {
//   post: PropTypes.shape({
//     date: PropTypes.string.isRequired,
//     description: PropTypes.string.isRequired,
//     image: PropTypes.string.isRequired,
//     imageLabel: PropTypes.string.isRequired,
//     title: PropTypes.string.isRequired,
//   }).isRequired,
// };

export default PaymentDetails;
